import ButtonWarning from "@/components/common/ButtonWarning";
import Link from "@/components/common/LinkNext";
import Text from "@/components/common/Typography/Text";
import Title from "@/components/common/Typography/Title";
import HotelsIconV2 from "@/components/icons/HotelsIconV2";
import LocationV2Icon from "@/components/icons/LocationV2Icon";
import StarIcon from "@/components/icons/StartIcon";
import { useIsDesktop } from "@/hooks/app/useIsDesktop";
import { useTERouter } from "@/hooks/app/useTERouter";
import { useTETranslation } from "@/hooks/app/useTETranslation";
import { getValidDayjs } from "@/utils/safeParse/getValidDayjs";
import { Card, CardProps, Col, Row, theme } from "antd";
import { useTranslation } from "react-i18next";


type HotelDealItemProps = CardProps & {
  itemType?: "sample" | "default";
  data: any;
  styles?: any
};

const HotelDealItem = ({
  data,
  className,
  itemType = "default",
  ...props
}: HotelDealItemProps) => {
  const token = theme.useToken().token
  const { getFormatCurrency } = useTETranslation()
  const originalPrice = parseFloat(data?.originalPrice || "0")
  const flashPrice = parseFloat(data?.flashPrice || "0")
  const { t } = useTranslation()

  const percent = Math.floor(((originalPrice - flashPrice) / (originalPrice || 1)) * 100)

  const isAgodaSource = String(data?.productMetaData?.source || "").toUpperCase() === "AGODA"
  const hotelHref = isAgodaSource
    ? `/hotels${data?.productMetaData?.slug || ""}`
    : `/khach-san/${data?.productMetaData?.slug}`

  return (
    <Link
      href={hotelHref}
      target="_blank"
      aria-label={data?.productName ? `Khách sạn ${data.productName}` : "Xem khách sạn"}
      className={`${className ? `${className} ` : ""}home__deals-hotels--item`}
      style={{ display: 'block' }}
    >
    <Card
      cover={
        <div style={{ height: "200px", overflow: "hidden", position: "relative", background: token.colorFillTertiary }}>
          {data?.productMetaData?.banner ? (
            <img
              alt={data?.productName ? `Khách sạn ${data.productName}` : "Khách sạn giá tốt"}
              style={{ height: "100%", width: "100%", objectFit: "cover" }}
              src={data.productMetaData.banner}
            />
          ) : (
            <Row justify="center" align="middle" style={{ height: "100%" }}>
              <HotelsIconV2 style={{ fontSize: "3.2rem", color: token.colorTextDisabled }} />
            </Row>
          )}
          <Row
            style={{
              height: '10rem',
              width: '10rem',
              backgroundColor: token.colorPrimary,
              position: 'absolute',
              top: '-5rem',
              left: '-2rem',
              borderRadius: '50%',
            }}
          >
            <Col
              style={{
                position: 'absolute',
                bottom: '10%',
                right: '20%',
                fontSize: '2rem',
                color: 'white'
              }}
            >
              <Text
                style={{
                  color: 'white'
                }}
              >
                {percent}%
              </Text>
            </Col>
          </Row>
        </div>
      }
      style={{
        width: '100%',
        minHeight: '100%',
        overflow: 'hidden'
      }}
      styles={{
        ...props.styles,
        body: {
          padding: "1.2rem",
          display: "flex",
          flexDirection: "column",
          ...props.styles?.body,
        },
      }}
      {...props}
    >
      <Row style={{ minHeight: '14.4rem' }}>
        <Col span={24}>
          <Row style={{ marginBottom: '0.5rem' }}>
            <Title ellipsis={{ tooltip: true }} level={5} style={{ fontSize: '1.6rem' }} className="home__deals-hotels--item-title">
              {data.productName}
            </Title>
          </Row>
          <Row style={{ marginBottom: '0.5rem' }}>
            <Text style={{ width: '100%', fontSize: '1.3rem' }} className="home__deals-hotels--item-name">
              <Text ellipsis={{ tooltip: data.productMetaData?.hotelLocation, }} style={{ width: '100%', display: 'block' }}><LocationV2Icon style={{ fontSize: "1.6rem" }} />{" "} {data.productMetaData?.hotelLocation}</Text>
            </Text>
          </Row>
          <Row>
            <Text className="home__deals-hotels--item-star">
              {Array(Math.ceil(data?.productMetaData?.rating || 1)).fill(null).map((_, idx) => {
                return (
                  <StarIcon key={idx} style={{ fontSize: "1.6rem", marginRight: '0.2rem' }} />
                )
              })}
            </Text>
          </Row>
          <Row gutter={[10, 10]} align='middle'>
            <Col>
              <Text type='secondary' style={{ fontSize: '1.4rem' }}>
                <Text className="hotel__comments--feedback" style={{ fontSize: '1.4rem' }}>{data?.productMetaData?.ratingScore || 0}</Text>/10
              </Text>
            </Col>
            <Col>
              <Text style={{ fontSize: '1.4rem', lineHeight: 1 }} strong>{t("common.great")}</Text>
            </Col>
            <Col>
              {/* Dùng Text (không phải Typography.Link) vì cả Card đã nằm trong
                  <Link>; anchor lồng anchor là HTML không hợp lệ. */}
              <Text underline style={{ fontSize: '1.4rem' }}>
                {data?.reviewCount} {t("common.comment", { s: data?.reviewCount > 1 ? "s" : "" })}
              </Text>
            </Col>
          </Row>
        </Col>
        <Col style={{ alignSelf: 'end' }} span={24}>
          <Row justify="end">
            <Text type='secondary' strong delete style={{ textAlign: 'end' }}>
              {/* {t("deals.price_after_tax")}:{" "} */}
              {getFormatCurrency(parseFloat(data?.originalPrice || "0"))}
            </Text>
          </Row>
          <Row align="middle" gutter={[10, 10]} justify="end">
            <Col>
              <Text strong type="danger" style={{ textAlign: 'end', fontSize: '1.8rem' }}>
                {getFormatCurrency(parseFloat(data?.flashPrice || "0"))}
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
    </Link>
  );
};

export default HotelDealItem
